import {
    AiFillGithub,
   
  } from "react-icons/ai";
  import { FaFacebookF } from "react-icons/fa";
  import { FaLinkedinIn } from "react-icons/fa";
  import { FaWhatsapp  } from "react-icons/fa6";
function Footer(){
    let date = new Date();
    let year = date.getFullYear();
    return(
          
        <footer className="  text-light py-4" style={{backgroundColor:"#1a1328"}}>
        <div className="container">
          <div className="row">
            <div className="col-md-4 ">
              <h6>Designed and Developed by Weam Ibrahim</h6>
            </div>
            <div className="col-md-4 ">
              <h6 className="text-center">Copyright © {year}</h6>
            </div>
            <div className="col-md-4 ">
              <ul className="list-inline  text-center">
                <li className="list-inline-item mx-3">
                  <a
                    href="https://github.com/weamibrahim"
                    style={{ color: "white" }}
                   
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="list-inline-item mx-3">
                 
                  <a href='https://www.facebook.com/weaam.ebrahim.3?mibextid=ZbWKwL' style={{ color: "white" }}>
                 <FaFacebookF  />
         </a>





                </li>
                <li className="list-inline-item mx-3">
                  <a
                    href="https://www.linkedin.com/in/weamibrahim"
                    style={{ color: "white" }}
                  
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="list-inline-item mx-3">
                <a href='https://wa.me/201008864924' style={{ color: "white" }}>
            <FaWhatsapp />
         </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

    )
}
export default Footer